import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        boxShadow: "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
        borderRadius: 10,
        padding: 10,
        backgroundColor: theme.palette.primary.contrastText,
        margin: 10
    },
    tableCell: {
        fontSize: 13
    },
    tableBody: {
        fontSize: 12
    },
}))
